import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import FooterSection from "../../../components/FooterSection";
import PartnersList from "../../../components/PartnersList";
import SectionMain from "../../../components/SectionMain";
import Title from "../../../components/Title";
import { STYLE } from "./style";

const useStyles = makeStyles(STYLE);

const PartnersPageMobile = ({ handleSubmitForm }) => {
  const classes = useStyles();
  const [state, setState] = useState({ email: "" });

  return (
    <SectionMain noPadding>
      {/* <BePartner navigate={handleSubmitForm}></BePartner> */}

      <SectionMain className={classes.title}>
        <Title
          align="center"
          letterSpacing="2"
          fontWeight="800"
          className={classes.center}
          size="medium"
        >
          PARCEIROS EM DESTAQUE
        </Title>
      </SectionMain>

      <SectionMain className={classes.container}>
        <PartnersList />
      </SectionMain>

      <SectionMain className={classes.title}>
        <Title
          align="center"
          letterSpacing="2"
          fontWeight="800"
          className={classes.center}
          size="medium"
        >
          MeditaBem: um círculo virtuoso
        </Title>
      </SectionMain>

      <SectionMain className={classes.container}>
        <Title size="small" align="left">
          Assim como nós, você deseja oferecer conteúdos de bem-estar de forma
          acolhedora e simples, ajudando pessoas de todas as idades e estilos a
          adotar hábitos mais saudáveis em seu dia-a-dia? Então, junte-se ao
          time de autores e professores do MeditaBem e conte com um canal
          especializado para divulgar seu trabalho de uma forma leve e prática.
          <br />
          <br />
          Além de acompanhar os conteúdos, a comunidade do MeditaBem também tem
          acesso à agenda de parceiros no próprio aplicativo, com nome,
          fotografia, apresentação e os dados de contato que cada autor e
          professor deseja publicar, incluindo sua mídia social para que as
          pessoas possam seguir e prestigiar.
          <br />
          <br />
          Gostou do MeditaBem e deseja saber mais sobre como participar? Deixe
          seus dados e em breve entraremos em contato. Obrigado :)
        </Title>
      </SectionMain>

      {/* <SectionMain item xs={12} className={classes.section}>
        <SectionMain className={classes.modal}>
          <Title color='#282828' align='center' className={classes.txtMobile}>
            <Title
              align='center'
              letterSpacing='2'
              fontWeight='800'
              className={classes.center}
              size='medium'
            >
              Explore e descubra seu perfil
            </Title>
            <br />
            Um espaço exclusivo somente para os seus conteúdos, informações e
            contato. <br /> Acompanhe os resultados dos seus conteúdos em nossa
            plataforma exclusiva
            <br />
            <br />
          </Title>
          <img src={banner} className={classes.image} />
        </SectionMain>
      </SectionMain> */}

      {/* <SectionMain item xs={12} className={classes.section}>
        <SectionMain className={classes.modal}>
          <Title color='#282828' align='center' className={classes.txtMobile}>
            <Title
              align='center'
              letterSpacing='2'
              fontWeight='800'
              className={classes.center}
              size='medium'
            >
              Faça parte do time <br /> MeditaParceiros
            </Title>
            <br />
            Leve sua mensagem muito mais longe e acompanhe os resultados dos
            seus conteúdos em nossa <br /> plataforma exclusiva. Entre em
            contato e experimente!
            <br />
            <br />
          </Title>
          <SectionMain className={classes.formBlock}>
            <FormParceiro mobile={true} handleSubmitForm={handleSubmitForm} />
          </SectionMain>
        </SectionMain>
      </SectionMain> */}

      <SectionMain>
        <FooterSection mobile hideNewsletter={true} />
      </SectionMain>
    </SectionMain>
  );
};

export default PartnersPageMobile;
